
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {RouterProvider} from 'react-router-dom'
import { router } from './Routes/Routes/Routes';
function App() {
  return (
    <RouterProvider router={router}></RouterProvider>
  );
}
export default App;
